<template>
	<v-app>
		<app-header />
		<v-main class="bg-surface-page">
			<router-view />
		</v-main>

		<v-snackbar v-model="uiStore.snackbar.show" :color="uiStore.snackbar.color" :timeout="5000" location="bottom">
			{{ uiStore.snackbar.text }}
		</v-snackbar>
	</v-app>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/storeAuth';
import { useUiStore } from '@/stores/storeUi';
import AppHeader from '@/components/app/Header.vue';
import SupportBot from '@/components/support/SupportBot.vue';

const authStore = useAuthStore();
const uiStore = useUiStore();

onMounted(() => {
	authStore.init();
});
</script>
